import {
  IBasePagingRes,
  IBaseResponseModel,
} from "../../models/common/models.type";
import { ILoginResponse, IGoogleLoginRequest } from "../../models/auth";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { HistoryTranslate } from "../../page/main/AiToolsPage";
import { envConfig } from "../../config/env.config";
import {
  EQrcodeRequest,
  IGetPageHistoryTransactionByUser,
} from "../../models/payment";

const API = ApiEndpoints.PAYMENT;
const baseURL = envConfig.PAYMENT_ENDPOINT;

const GetPageHistoryTransactionByUser = (
  data: IGetPageHistoryTransactionByUser,
): Promise<IBasePagingRes<HistoryTranslate>> => {
  return api.get(baseURL, API.GetPageHistoryTransactionByUser.url, {
    params: data,
  });
};

const GetFileHistoryTranslate = async (
  historyId: string,
): Promise<IBaseResponseModel<HistoryTranslate>> => {
  return api.get(
    baseURL,
    API.GetFileHistoryTranslate.url + "?historyId=" + historyId,
  );
  //return res;
};

const GetHistoryTranslate = async (
  orderId: string,
): Promise<IBaseResponseModel<HistoryTranslate>> => {
  return api.get(baseURL, API.GetHistoryTranslate.url + "?orderId=" + orderId);
  //return res;
};

const GetQrCode = async (
  data: EQrcodeRequest,
): Promise<IBaseResponseModel<string>> => {
  return api.post(baseURL, API.GetPaymentQrCode.url, data);
  //return res;
};

const PaymentService = {
  GetPageHistoryTransactionByUser,
  GetHistoryTranslate,
  GetQrCode,
  GetFileHistoryTranslate,
};

export default PaymentService;
